import React, { useRef } from 'react';
import {
  ArrowDownTrayIcon,
  BuildingStorefrontIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';
import {
  TWModal,
  TWButton,
  TWSelect,
  TWDateRangePicker,
} from '../../../components/ui';

export default function DownloadCsvModal({
  show,
  onClose,
  storeList,
  csvForm,
  onChange,
  loading,
  onSubmit,
}) {
  const cancelRef = useRef(null);

  return (
    <TWModal
      open={!!show}
      onClose={onClose}
      title="Download order CSV"
      description="Export a detailed order breakdown for a store and date range."
      size="xl"
      initialFocus={cancelRef}
      showCloseButton
      footer={
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <TWButton
            ref={cancelRef}
            label="Cancel"
            disabled={loading}
            onClick={onClose}
          />
          <TWButton
            variant="primary"
            icon={ArrowDownTrayIcon}
            label={loading ? 'Exporting…' : 'Download CSV'}
            disabled={loading}
            onClick={onSubmit}
          />
        </div>
      }
    >
      <div className="space-y-4">
        <TWSelect
          label="Store"
          labelIcon={BuildingStorefrontIcon}
          placeholder="Select a store"
          onChange={(e) => onChange(e, 'storeid')}
          value={csvForm.storeid || undefined}
          options={storeList.map((item) => ({
            label: item.name,
            value: item.id,
          }))}
        />
        <TWDateRangePicker
          label="Date range"
          labelIcon={CalendarDaysIcon}
          onChange={(e) => onChange(e, 'date')}
        />
      </div>
    </TWModal>
  );
}
